﻿import { NgModule } from "@angular/core";
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { HeaderComponent } from './header.component'
import { FooterComponent } from './footer.component'



@NgModule({
    imports: [BrowserModule,
        RouterModule],
    exports: [HeaderComponent, FooterComponent],
    declarations: [HeaderComponent, FooterComponent]
})
export class SharedModule {

}